import {
    LandingCheckout,
    LandingCheckoutPayload,
    LandingCheckoutStatusEnum,
    SimpleLandingCheckout,
    AccountTerms,
    ConnectPayload,
    AccountConnect,
    CreateAccountConnect,
    LandingCheckoutScope
} from "@dev/ee-api/ee-api-models";
import { AxiosPromise, AxiosResponse } from "axios";
import { request } from "./request";

export type GetCheckoutsParams = {
    from?: string;
    to?: string;
    search?: string;
    limit?: number;
    offset?: number;
    statusList?: LandingCheckoutStatusEnum[]
    loadingTemplates?: boolean,
    page?: number,
    templatesList?: LandingCheckout[],
    count?: number
    publishedCount?: number,
    unpublishedCount?: number
    scope?: LandingCheckoutScope;
};

export const loadCheckouts = ({ limit, offset, statusList, search, from, to, scope = LandingCheckoutScope.Private}: GetCheckoutsParams): AxiosPromise<SimpleLandingCheckout[]> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsListGet(statusList, scope, search, from, to, limit, offset).then((resp): AxiosResponse<SimpleLandingCheckout[]> => resp);
};

export const loadCheckout = (name: string): Promise<LandingCheckout> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsByNameGet(name).then((resp): LandingCheckout => resp.data);
};

export const updateCheckoutStatus = (name: string, status: LandingCheckoutStatusEnum): Promise<LandingCheckoutStatusEnum> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsByNameByStatusPut(name, status).then((resp): LandingCheckoutStatusEnum => resp.data);
}

export const saveCheckout = (checkout: LandingCheckoutPayload, name?: string): Promise<LandingCheckout> => {
    const { Checkouts } = request();
    if (name) {
        return Checkouts.checkoutsByNamePut(name, checkout).then((resp): LandingCheckout => resp.data);
    }

    return Checkouts.checkoutsPost(checkout).then((resp): LandingCheckout => resp.data);
};

export const loadCheckoutsTerms = (): AxiosPromise<AccountTerms> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsTermsGet();//return Checkouts.checkoutsTermsGet().then((resp): AxiosResponse<AccountTerms> => resp);
};

export const updateCheckoutsTerms = (payload: AccountTerms): AxiosPromise<AccountTerms> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsTermsPost(payload).then((resp): AxiosResponse<AccountTerms> => resp);
};
export const modifyCheckoutsTerms = (payload: AccountTerms): AxiosPromise<AccountTerms> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsTermsPut(payload).then((resp): AxiosResponse<AccountTerms> => resp);
};

export const deleteCheckouts = (checkoutNames: string[]): AxiosPromise<void> => {
    const { Checkouts } = request();

    return Checkouts.checkoutsDelete(checkoutNames);
};

// checkoutsAccount
export const fetchCheckoutsAccount = (): AxiosPromise<AccountConnect> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsAccountGet().then((resp): AxiosResponse => resp);
};
export const updateCheckoutsAccount = (payload: ConnectPayload): AxiosPromise<CreateAccountConnect> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsAccountPost(payload);
};
